export const trackCallClick = (source) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'call_click', {
      event_category: 'engagement',
      event_label: source,
      value: 1,
    });
  }
};

const SHOP_HOST = 'menlofloristonline.com';

export const initShopClickTracking = () => {
  const handler = (e) => {
    const link = e.target.closest && e.target.closest('a[href]');
    if (!link || !link.href.includes(SHOP_HOST)) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'shop_click', {
        event_category: 'outbound',
        event_label: window.location.pathname,
        link_text: (link.textContent || '').trim().slice(0, 60),
        value: 1,
      });
    }
  };
  document.addEventListener('click', handler);
  return () => document.removeEventListener('click', handler);
};
